var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloudPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 139,
    viewBox: "0 0 140 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0133 78.75C59.1172 78.75 58.3551 79.3717 58.0141 80.2005C56.4867 83.9136 52.8334 86.5278 48.5694 86.5278C42.9315 86.5278 38.3611 81.9573 38.3611 76.3194V63.6806C38.3611 58.0426 42.9315 53.4722 48.5694 53.4722C53.4086 53.4722 57.4613 56.8393 58.5125 61.3585C58.7478 62.37 59.5834 63.1944 60.6218 63.1944H78.2222C79.2961 63.1944 80.1667 62.3239 80.1667 61.25V59.3056C80.1667 57.3895 79.8889 55.4773 79.2004 53.6892C74.9911 42.7572 64.3875 35 51.9722 35H45.1667C29.0584 35 16 48.0584 16 64.1667V75.8333C16 91.9416 29.0584 105 45.1667 105H51.9722C64.7304 105 75.5753 96.8085 79.5344 85.398C79.9498 84.201 80.1667 82.9337 80.1667 81.6667V80.6944C80.1667 79.6206 79.2961 78.75 78.2222 78.75H60.0133Z",
    fill: "#F37321"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2566 35H100.057C109.657 35 115.157 37.0667 120.557 41.2C125.957 45.3333 128.557 51.4333 128.557 59.5C128.557 67.5667 125.957 74.5333 120.557 78.4C115.223 82.2667 109.723 84.2 100.057 84.2H89.5566V102.3C89.5566 103.033 89.29 103.667 88.7566 104.2C88.2233 104.733 87.59 105 86.8566 105H69.2566C68.5233 105 67.89 104.733 67.3566 104.2C66.8233 103.667 66.5566 103.033 66.5566 102.3V37.7C66.5566 36.9667 66.8233 36.3333 67.3566 35.8C67.89 35.2667 68.5233 35 69.2566 35ZM100.057 54.0004H89.5569V65.0004H100.057C103.094 65.0004 105.557 62.538 105.557 59.5004C105.557 56.4629 103.094 54.0004 100.057 54.0004Z",
    fill: "#889199"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5574 78.7352V101.083C72.5695 97.6046 77.2249 92.042 79.5354 85.3832C79.9507 84.1862 80.1676 82.9189 80.1676 81.6519V80.6797C80.1676 79.6058 79.2971 78.7352 78.2232 78.7352H66.5574ZM66.5574 38.8877V63.1797H78.2232C79.2971 63.1797 80.1676 62.3091 80.1676 61.2352V59.2908C80.1676 57.3747 79.8899 55.4625 79.2014 53.6744C76.7933 47.4205 72.2927 42.2057 66.5574 38.8877Z",
    fill: "#9B0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudPortal);
export default __webpack_public_path__ + "static/media/icon-cloud-portal.c89720bb3f9c79124de38be54013ea30.svg";
export { ForwardRef as ReactComponent };